const Order = () =>
  import(/* webpackChunkName: "order" */ "@/app/admin/order/order");
const OrderDetail = () =>
  import(/* webpackChunkName: "order" */ "@/app/admin/order/order-detail");
  const OrderEmployment = () =>
  import(/* webpackChunkName: "order" */ "@/app/admin/order/employment");
  const OrderPartTimeTask = () =>
  import(/* webpackChunkName: "order" */ "@/app/admin/order/part-time-task");

export default [
  {
    path: "order/:status",
    name: "order",
    component: Order,
    meta: { title: "订单", key: "order", permission: "post_manager" }
  },
  {
    path: "order/detail/:id",
    name: "order-detail",
    component: OrderDetail,
    meta: { title: "订单-详情", key: "order", permission: "post_manager" }
  },
  // /*  灵活用工  */  
  {
    path: "/employment",
    name: "order-employment",
    component: OrderEmployment,
    meta: { title: "灵活用工订单", key: "employment-order" }
  },
  {
    path: '/partTimeTask',
    name: "order-partTimeTask",
    component: OrderPartTimeTask,
    meta: { title: "赚钱任务", key: "part-time-task-order" }
  }
];
